export const INDEX = 11;

export const CLIENTS = [
  { index: 1, appId: 'com.diet.master', appName: 'My App', identifier: 'testing' },
  { index: 2, appId: 'com.go.abieta', appName: 'Abieta', identifier: 'abietadm' }, // ios: com.goabieta // android: com.go.abieta - 25nov //14jan
  { index: 3, appId: 'com.locarb.kwt', appName: 'Locarb', identifier: 'locarbdm' }, // ios: com.locarb // android: com.locarb.kwt - 24nov //14jan
  { index: 4, appId: 'com.envisiondiet', appName: 'XIV Restaurant', identifier: 'xiv'}, //com.envisiondiet
  { index: 5, appId: 'com.dietcircle', appName: 'Diet Circle', identifier: 'dietcircledm' }, // - 25nov
  { index: 6, appId: 'fit.dietmaster.fitstationdm', appName: 'Fit Station', identifier: 'fitstationdm' }, // - 25nov//14jan//27th Jan
  { index: 7, appId: 'fit.dietmaster.chefpaul', appName: 'Chef Paul', identifier: 'chefpaul' },
  { index: 8, appId: 'fit.dietmaster.eatsmart', appName: 'Eat Smart KW', identifier: 'eatsmart' }, // - 25 nov//14jan//27th Jan
  { index: 9, appId: 'fit.dietmaster.xfit', appName: 'X Fit KW', identifier: 'xfit' },
  { index: 10, appId: 'fit.dietmaster.nutrilifedm', appName: 'Nutri Life KSA', identifier: 'nutrilifedm' }, // - 25nov
  { index: 11, appId: 'fit.dietmaster.healthchart', appName: 'Health Chart', identifier: 'healthchart' },
  { index: 12, appId: 'fit.dietmaster.eightysixhealthy', appName: '86 Healthy', identifier: '86healthy' },
  { index: 13, appId: 'fit.dietmaster.xdiet', appName: 'XDiet', identifier: 'xdiet' },
  { index: 14, appId: 'com.kocmgrmeals', appName: 'NCC Meals', identifier: 'kocmgrmeals' },
  { index: 15, appId: 'com.swaps.diet', appName: 'Swaps Diet', identifier: 'swaps' },
  { index: 16, appId: 'com.roots.diet', appName: 'Roots Diet', identifier: 'roots' }, // - 20 nov
  { index: 17, appId: 'com.forma.diet', appName: 'Forma Diet', identifier: 'forma' }, //14jan
    { index: 18, appId: 'com.thelofat.ios', appName: 'Lofat Eats', identifier: 'lofat' },

];


